import React from "react";
import classes from "./BranchesCard.module.css";
import { extractTextFromHTML } from "../../../../components/extract-from-html/ExtractFromHtml";
import { useNavigate } from "react-router-dom";

const BranchCard = ({ data }) => {
  const navigate = useNavigate();

  return (
    <div
      className={`${classes.outer} border-primary-300`}
      onClick={() => navigate(`/branch/${data?.slug}`)}
    >
      <img
        className={classes.branchImage}
        src={data?.images?.find((item) => item?.mainImage == "yes")?.url}
        alt={data?.images?.find((item) => item?.mainImage == "yes")?.imageTag}
      />
      <div className={classes.rightDiv}>
        <div className={classes.locationDiv}>
          <img className={classes.locationIcon} alt="Icon" src="/img/location-blue.svg" />
          <h2 className="primary-300" title={data?.location}>{data?.location}</h2>
        </div>
        <h3 className="primary-300" title={data?.name}>{data?.name}</h3>
        <div className={classes.contactDiv}>
          <img src="/img/contact-blue.svg" alt="contact" />
          <h2 className="primary-300">{data?.phoneNumber}</h2>
        </div>
        <button className="bg-primary-300">Explore</button>
      </div>
    </div>
  );
};

export default BranchCard;
